<div class="text-center">
    <fa-icon class="{{color}}" [icon]="['fas', 'satellite-dish']" size="3x"></fa-icon>

    <p class="{{color}}">{{message}}</p>

    <div class="container" [hidden]="showProsseguir">
        <div class="row">
          <div class="col" style="padding: 0 !important">
            <div class="pb col">
                <button type="button" class="btn btn-primary" [disabled]="usuarioBloqueado" (click)="verificar()">
                    VERIFICAR &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'check']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>
</div>